import { Component, computed, input } from '@angular/core';

import { TranslatePipe } from '@ta/translation';
import { LabelComponent } from '@ta/ui';

import { BaseComponent } from 'src/app/features/core/abstract/baseComponent';
import { CompanyRevenue } from 'src/app/services/company/dto/revenue';

export const companyRevenueLabel = (revenue: CompanyRevenue): string | null => {
  const name = CompanyRevenue[revenue];
  return name ? `app.companies.revenue.${name}` : null;
};

@Component({
  selector: 'app-company-revenue',
  standalone: true,
  imports: [LabelComponent, TranslatePipe],
  templateUrl: './company-revenue.html',
})
export class CompanyRevenueComponent extends BaseComponent {
  public revenue = input.required<CompanyRevenue>();

  public readonly label = computed(() => companyRevenueLabel(this.revenue()));
}
